import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

module.exports = {
    ...storeModuleFactory({
        name:         'attachments',
        endpoint:     endpoints.serviceNow.uploadAttachments,
        timeout:      TIMEOUT_STORE.TIMEOUT_STORE_SMALL,
        extraActions: [{
            method: 'create',
            action: 'createServiceNow',
            url:    endpoints.serviceNow.uploadAttachments,
            start:  state => ({
                ...state,
                isUploading: true,
                error:       null
            }),
            success: state => ({
                ...state,
                isUploading:   false,
                didInvalidate: true,
                error:         null
            }),
            transform: item => item
        }]
    })
};





// WEBPACK FOOTER //
// ./src/modules/store/serviceNowUploadAttachments.js